export enum PlaceholderImages {
  BLANK_4_3 = '/ncis-assets/images/placeholders/blank-images/4x3.png',
  USER_AVATAR = '/ncis-assets/images/placeholders/blank-images/user.png',
  AUTHENTICATION_IN_PROGRESS = '/ncis-assets/images/placeholders/authentication.svg',
  AUTHENTICATION_FAILED = '/ncis-assets/images/placeholders/authentication-failed.svg',
  AUTHENTICATION_SUCCESSFUL = '/ncis-assets/images/placeholders/authentication-success.svg',
  SCHEDULE_AVATAR = '/ncis-assets/images/placeholders/blank-images/schedule-avatar.png'
}
